import _config from '../../config';

export default (state = { ..._config }) => state;
